<template>
    <div class="tab-content">
        <div class="tab-inner-content">
            <div class="frame-wrapper">
                <iframe :src="activeContent.main.src" v-if="(activeContent.main.src.length > 0)" scrolling="no" frameborder="0" style="width: 808px;height: 460px;margin-left: 7%;"></iframe>
                <br/>
                <div v-if="(activeContent.sub.src.length > 0 || activeContent.sub.text.length > 0)"
                     style="text-align:center; width: 725px;margin-left: 7%;">
                    <a :href="activeContent.sub.src">{{activeContent.sub.text}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ContentFrame",
        props: ['activeContent']
    }
</script>

<style scoped>
    .tab-inner-content {
        transition: all .3s ease-in;
        height: 100%;
        width: 100%;
    }
</style>